<template>
  <div>
    <b-modal
      id="project-information"
      size="lg"
      centered
      :title="title"
      ok-only
      no-stacking
      no-close-on-backdrop
      @close="closeModal"
    >
      <ProjectInfoForm
        :value="formValue"
        :isValidationLoading="isValidationLoading"
        @input="onInputChange"
        @validate-user="validateUser"
      />
      <b-row v-if="projectNameExists" class="text-danger mx-2 my-2">
        There is another project with the same name. Please choose another name.
      </b-row>
      <template #modal-footer>
        <b-button variant="primary" @click="closeModal">Cancel</b-button>
        <b-button :disabled="disabled" variant="primary" @click="saveNewProject"
          >Save</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getUserAsync } from '../../utils/getUserAsync';
import ProjectInfoForm from './ProjectInfoForm.vue';
import { MODAL_FILTERS } from '../../constants/constants';
import { logError } from '@/utils/loggerUtils';

export default {
  name: 'AddProjectModal',
  components: {
    ProjectInfoForm,
  },
  props: {
    modalShow: Boolean,
    projectToModify: Object,
    title: String,
  },
  emits: ['toggle', 'fetch'],
  data() {
    return {
      formValue: {
        projectName: '',
        projectMembers: [],
        errorMessage: '',
      },
      isValidationLoading: false,
    };
  },
  computed: {
    ...mapGetters(['projects']),
    projectNameExists() {
      return (
        !!this.formValue.projectName &&
        this.projects.findIndex((p) => p.text === this.formValue.projectName) >
          -1
      );
    },
    disabled() {
      return (
        this.projectNameExists ||
        this.isValidationLoading ||
        !!this.formValue.errorMessage ||
        !this.formValue.projectName
      );
    },
  },
  mounted() {
    if (this.modalShow) {
      this.showModal();
    }
  },
  methods: {
    showModal() {
      this.$bvModal.show('project-information');
    },
    closeModal() {
      this.$emit('toggle');
    },
    onInputChange(newFormValue) {
      this.formValue = newFormValue;
    },

    async validateUser(user) {
      if (!user) {
        this.isValid = true;
        this.formValue.errorMessage = '';
        return;
      }

      this.isValidationLoading = true;
      try {
        const userRole = await getUserAsync(user);
        this.isValid = !!userRole.data.getUserRole;
        this.formValue.errorMessage = this.isValid
          ? ''
          : `${user} is not a valid user email.`;
      } catch (e) {
        logError(e);
        this.isValid = false;
        this.formValue.errorMessage =
          'Something went wrong on our end please refresh and try again.';
      } finally {
        this.isValidationLoading = false;
      }
    },

    saveNewProject() {
      const projectPreference = {
        searchMode: this.selectedSearchMode,
        products: MODAL_FILTERS.productName.selected,
      };
      const project = {
        name: this.formValue.projectName,
        description: '',
        projectPreference: JSON.stringify(projectPreference),
      };

      this.$store
        .dispatch('STORE_PROJECT', {
          project,
          users: this.formValue.projectMembers,
        })
        .then((res) => {
          if (res.status === 'STORE_PROJECT_SUCCESS') {
            this.$router.push({
              path: `/project-searchdocs-dashboard/?projectID=${res.userProject.project.id}`,
            });
            this.$emit('fetch');
            this.closeModal();
          }
        });
    },
  },
};
</script>

<style></style>
